/**
 * WebFeatureService要素服务类 WmsLayer
 */
import L from 'leaflet';
// 引入 leaflet.markercluster
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster";
import context from '../context';
export default L.Layer.extend({
    options: {
        layerId: null,
        geoJson: null
    },
    _mapLayer:null,
    // 定义初始化方法
    initialize: function (options) {
        // console.log(context.map);
        // console.log(this);
        // console.log(options);
        // 在初始化方法中可以接收一些参数，并进行一些初始化操作
        L.setOptions(this, options);
    },

    // 在 addLayer 方法中定义如何向地图添加图层
    onAdd: function (map) {
        // console.log(this);
        // console.log(map);
        // 在这里可以添加图层到地图上
        // 比如，创建 DOM 元素并将其添加到地图容器中

        this._mapLayer = L.tileLayer.wms(this.options.url,
            {
                layers: this.options.layerId,
                format: 'image/png',
                transparent: true,
                attribution: "Weather data © 2012 IEM Nexrad"
            }
        );
        this._mapLayer.addTo(this._map);
        // this._map.addLayer(this._mapLayer);
        // this._update();
    },

    removeLayer: function (map) {
        map.removeLayer(this._mapLayer);
    },

    // 在 removeLayer 方法中定义如何从地图移除图层
    onRemove: function (map) {
        console.log(map);
        // 在这里可以移除图层，清理资源等操作
    },

    _update:function (){
        if (!this._map) return;

    }
});